<template>
    <div class="diy-wrapper" :style="'height:'+ clientHeight + 'px;'">
        <div class="diy-left">
            <div class="">
                <el-collapse v-model="opens">
                    <el-collapse-item v-for="(item, index) in leftMenu" :key="index" :title="item.title" :name="index">
                        <div class="module-list">
                            <div @click="addDom(module)" class="module-item" v-for="(module, index2) in item.list" :key="index2">
                                <div class="iconfont" :class="module.icon"></div>
                                <div class="name">{{module.cname}}</div>
                            </div>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
        <div class="diy-center">
            <Phone :items="items" :page="page" :currentIndex="selectedIndex" @handleModule="handleModule"></Phone>
        </div>
        <div class="diy-right">
            <template v-if="curItem">
                <nav-menu :curItem="curItem" v-if="curItem.name == 'menus'"></nav-menu>
                <page-title :curItem="page" :pageName="page_name" v-else-if="curItem.name == 'pageTitle'" @changePageName="changePageName"></page-title>
                <EGoodsList :curItem="curItem" v-else-if="curItem.name == 'goodsList'"></EGoodsList>
                <editor :curItem="curItem" v-else></editor>
            </template>
        </div>
        <div class="diy-save">
            <el-button type="primary" @click="saveDiy">保存</el-button>
        </div>
    </div>
</template>

<script>
    import { inArray } from '@/utils/util';
    import _ from 'lodash';
    import mPage from './components'
    import Phone from './phone/index.vue'
    import Editor from './editor/index.vue'
    import NavMenu from './editor/nav.vue'
    import EGoodsList from './editor/egoodslist.vue'
    import pageTitle from './editor/pageTitle.vue';

    export default {
        name: "componnent-diy",
        components: {
            ...mPage,
            Phone,
            Editor,
            NavMenu,
            EGoodsList,
            pageTitle
        },
        props: {
        },
        data() {
            return {
                opens: [0, 1, 2],
                leftMenu: [],
                componnents: [], // 左侧组件
                items: [], // 中间组件渲染
                rConfig: [], // 右侧组件配置
                clientHeight: '',

                curItem: false,
                selectedIndex: -1, // 选中的下标
                pageId: "",
                page_type: 0,
                page_name: '演示模板',
                page: {
                    title: '页面标题',
                    name: "pageTitle",
                    cname: '页面设置',
                    tabs: [
                    ],
                }
            }
        },
        created() {
            this.pageId = this.$route.query.id ? this.$route.query.id : 0;
            this.componnents = this.objToArr(mPage);
        },
        mounted() {
            this.$nextTick(() => {
                this.arraySort();
                if (this.pageId != 0) {
                    this.getPageInfo();
                }

                this.clientHeight = `${document.documentElement.clientHeight}` - 120;//获取浏览器可视区域高度
                let that = this;
                window.onresize = function () {
                    that.clientHeight = `${document.documentElement.clientHeight}` - 120;
                }
            });
        },
        methods: {
            getPageInfo: function () {
                this.axios.post('/store/diy/detail',{
                    pageId: this.pageId
                }).then((res) => {
                    if (res.code == 1) {
                        var detail = res.data.detail
                        this.page_name = detail.page_name
                        this.page_type = detail.page_type
                        this.page = detail.page_data.page
                        this.items = detail.page_data.items
                    } else {
                        return this.$message.error(res.msg)
                    }
                })
            },
            // 对象转数组
            objToArr(data) {
                let obj = Object.keys(data);
                let m = obj.map((key) => data[key]);
                return m;
            },
            // 数组排序
            arraySort() {
                let tempArr = [];
                let basis = {
                    title: "基础组件",
                    list: [],
                };
                let marketing = {
                    title: "营销组件",
                    list: [],
                };
                let tool = {
                    title: "工具组件",
                    list: [],
                };
                this.componnents.map((el, index) => {
                    if (el.type == 0) {
                        basis.list.push(el);
                    }
                    if (el.type == 1) {
                        marketing.list.push(el);
                    }
                    if (el.type == 2) {
                        tool.list.push(el);
                    }
                });
                //排序
                basis.list.sort(function(a, b){
                    return a.sort - b.sort
                });
                //排序
                marketing.list.sort(function(a, b){
                    return a.sort - b.sort
                });
                //排序
                tool.list.sort(function(a, b){
                    return a.sort - b.sort
                });
                tempArr.push(basis, marketing, tool);
                this.leftMenu = tempArr;
            },
            //左边配置模块点击添加；
            addDom(item) {
                let tempItem = _.cloneDeep(item);
                if (!this.onCheckAddDom(tempItem)) {
                    return false
                }
                var config = tempItem.data().defaultConfig
                if (config.name == "search_box") {
                    this.items.unshift(config);
                    this.setCurItem(0)
                } else {
                    this.items.push(config)
                    this.setCurItem(this.items.length - 1)
                }
            },
            setCurItem: function (index) {
                this.selectedIndex = index;
                if (-100 == index) {
                    this.curItem = this.page
                } else {
                    this.curItem = this.items[this.selectedIndex]
                }
            },
            handleModule: function (e) {
                switch (e.op) {
                    case 'select':
                        this.setCurItem(e.selectIndex)
                        break;
                    case 'delete':
                        var selectIndex = e.selectIndex
                        this.items.splice(e.selectIndex, 1);
                        if (this.items.length != selectIndex) {
                            this.setCurItem(selectIndex)
                        } else {
                            this.setCurItem(selectIndex - 1)
                        }
                        break;
                    case 'move':
                        var index = e.selectIndex
                        var type = e.extra
                        if (type) {
                            if (index == 0) {
                                return
                            }
                        } else {
                            if (index == this.items.length - 1) {
                                return
                            }
                        }
                        if (type) {
                            this.swapArray(this.items, index - 1, index);
                        } else {
                            this.swapArray(this.items, index, index + 1);
                        }

                        var newIndex = -1;
                        if (type) {
                            newIndex = index - 1;
                        } else {
                            newIndex = index + 1;
                        }
                        this.setCurItem(newIndex)
                        break;
                }
            },
            //数组元素互换位置
            swapArray(arr, index1, index2) {
                arr[index1] = arr.splice(index2, 1, arr[index1])[0];
                return arr;
            },
            /**
             * 验证新增Diy组件
             * @param type
             */
            onCheckAddDom (item) {
                const { items } = this
                // 验证xx组件只能存在一个
                if (item.name === 'search-box') {
                    const itemsTypes = items.map(item => item.name)
                    if (inArray(item.name, itemsTypes)) {
                        this.$message.warning('该组件最多存在一个')
                        return false
                    }
                }
                return true
            },
            changePageName: function (e) {
                this.page_name = e
            },
            saveDiy: function () {
                var val = this.items
                this.axios.post('/store/diy/save', {
                    pageId: this.pageId,
                    form: {
                        page_type: this.page_type,
                        page_name: this.page_name,
                        page_data: {
                            page: this.page,
                            items: val,
                        }
                    }
                })
                    .then((res) => {
                        this.loading = false;
                        this.pageId = res.data.id;
                        this.$message.success(res.msg);
                    })
                    .catch((res) => {
                        this.loading = false;
                        this.$message.error(res.msg);
                    });
            }
        }
    }
</script>

<style scoped lang="less">
    .diy-wrapper{
        max-width: 100%;
        min-width: 1100px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
        position: relative;
        .diy-left{
            min-width: 300px;
            max-width: 300px;
            border-radius: 4px;
            height: 100%;
            background-color: #fff;
        }
        .diy-center{
            flex: 1 1 0%;
            background: rgb(240, 242, 245);
            display: flex;
            justify-content: center;
            padding-top: 20px;
            padding-bottom: 20px;
            height: 100%;
            overflow: hidden;
            box-sizing: border-box;
        }
        .diy-right {
            width: 400px;
            height: 100%;
            border-radius: 4px;
            overflow-y: auto;
            overflow-x: hidden;
            background-color: #fff;
        }
        .diy-save{
            position: absolute;
            right: 0;
            top: 0;
            z-index: 2;
            height: 45px;
            width: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
    /deep/ .el-collapse-item__header{
        padding: 0px 15px;
    }
    .module-list{
        padding: 0 15px;
        display: flex;
        flex-wrap: wrap;
        .module-item{
            width: 33.33333%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            color: #666;
            cursor: pointer;
            border-radius: 5px;
            line-height: 1.6;
            .iconfont{
                font-size: 24px;
                color: #1890ff;
                line-height: 1.6;
            }
            .name{
                line-height: 1.7692307692;
            }
        }
    }
    /deep/ .el-input-number__decrease, /deep/ .el-input-number__increase {
        display: flex;
        justify-content: center;
        align-items: center;
        height: auto;
        position: absolute;
        z-index: 1;
        top: 1px;
        bottom: 1px;
        width: 32px;
        background: var(--el-fill-color-light);
        color: var(--el-text-color-regular);
        cursor: pointer;
        font-size: 13px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
</style>
